import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { trackWhatsAppClick } from "../utils/analytics";
import "../styles/FloatingWhatsApp.css";

const whatsappNumber = "525579118589";
const message =
  "Hola, me gustaría recibir más información sobre los cursos de Fundación Nican. ¿Me podrían orientar?";

function FloatingWhatsApp() {
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      className="floating-whatsapp"
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsAppClick("boton_flotante")}
      aria-label="Solicitar información por WhatsApp"
    >
      <span className="floating-whatsapp-icon-wrap">
        <FaWhatsapp className="whatsapp-icon" />
        <span className="whatsapp-status-dot" aria-hidden="true"></span>
      </span>
      <span className="floating-whatsapp-copy">
        <span className="floating-whatsapp-eyebrow">Respuesta rápida</span>
        <span className="floating-whatsapp-label">Habla con un asesor</span>
      </span>
    </a>
  );
}

export default FloatingWhatsApp;
